module.exports = __webpack_public_path__ + "static/media/item-dimension.c736f54a.png";